export type Dict<T = unknown> = Record<string, T>;
